export default ({
  isFirstLoading: true,
  fetching: {
    getCategories: false,
    saveCategory: false,
  },
  api: {
    categories: [],
  }
});